export const summaryRows: string[] = [
  'Volume 01 — Process Control Fundamentals: Control Loops, Process Dynamics & Final Control Elements',
  'Volume 02 — PID Control & Loop Tuning: P, I, D, Tuning Methods & Advanced Regulatory Control',
  'Volume 03 — Distributed Control Systems (DCS): Architecture, Configuration & Plant Operations',
  'Volume 04 — SCADA, RTUs & Telemetry: Supervisory Control of Distributed Assets',
  'Volume 05 — Industrial Communications & Protocols: Fieldbus, Modbus, Profibus, DNP3, OPC & Industrial Networks',
  'Volume 06 — HMI, Alarm Management, Historians, OT Cybersecurity & Troubleshooting',
  'Bonus 1 — PID Tuning Quick-Reference & Loop Diagnostic Cards',
  'Bonus 2 — Industrial Protocol Cheat Sheets: Modbus, HART, Profibus, DNP3 & OPC UA',
  'Bonus 3 — Control Room Alarm Response & Shift Handover Guide',
  'Bonus 4 — How to Read P&IDs, Loop Diagrams & Control Narratives',
  'Bonus 5 — Process Control & SCADA Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
